import styled from 'styled-components'
import { GRAYSCALE_400, NEUTRAL_100 } from '@styles/colors'
import { INTER } from '@styles/fonts'
import { safeAreaInset } from '@lib/telegram'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  align-items: center;
  gap: 16px;
`

export const MinimumAmountSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  align-items: center;
  margin: 16px 0;
`

export const MinimumAmountText = styled.span`
  font-family: ${INTER.regular};
  font-size: 13px;
  color: ${GRAYSCALE_400};
  text-align: center;
`

export const BoldText = styled.span`
  font-family: ${INTER.bold};
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`

export const KeyboardSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 24px;
`

export const KeyboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 4px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 12px ${safeAreaInset().bottom || 32}px 12px;
`